export const FEATURE_NAME = '@zerops/zef/ngrx-router';

export const NGRX_ROUTER_IDS_FEATURE_NAME = '@zerops/zef/ngrx-router-ids';
